import { Component, computed, inject, signal } from '@angular/core';
import { LocaleValue } from '@hjc/masterdata-types';
import { TranslateService } from '@ngx-translate/core';
import { LocalizationService } from '@services/localization.service';
import { TranslationStateService } from '@services/translation-state.service';

/**
 * Base component that provides translation and internationalization functionality.
 * This component focuses solely on translation services and language state management.
 */

@Component({ template: '' })
export abstract class BaseTranslatableComponent {
  protected translate = inject(TranslateService);
  protected localizationService = inject(LocalizationService);
  protected translationState = inject(TranslationStateService);

  protected lang = signal<LocaleValue>('fi');
  protected translationsReady = computed(() => this.translationState.translationsLoaded());

  constructor() {
    this.lang.set(this.localizationService.currentLang);

    this.translate.onLangChange.subscribe(() => {
      this.lang.set(this.localizationService.currentLang);
    });
  }
}
